import React, { Component } from 'react';
import './Enemies.css';
import Entity from './Entity';

export default class Enemies extends Component {

  slotWidth (slot) {

    const scale = slot.scale || 1;
    return ((33.6 * (scale || 1)) + "vh");
  }

  enemyScale (enemy) {

    return enemy?.model?.scale || 1;
  }

  slotStyle (slot) {

    const width = this.slotWidth(slot);
    return {
      width,
      minWidth: width,
      maxWidth: width,
      flexBasis: width
    };
  }

  render () {

    return (
      <div className="game-enemies">
      {
        this.props.src.map((slot, index) => {
          const enemy = slot.enemy;
          return <div key={"slot-" + index}
            className={"enemy-wrapper" + (!enemy ? " empty" : "") + (enemy && this.props.targeting && this.props.targeting.canTarget(enemy) ? " target-enemy" : "")}
            onMouseMove={() => { if (enemy && this.props.targeting) this.props.hoverTarget(enemy); }}
            onMouseOut={() => this.props.hoverTarget(null) }
            style={this.slotStyle(slot)}
            >
            { enemy ? <Entity onSelect={this.props.onSelect} src={enemy} scale={this.enemyScale(enemy)}/> : <div className="enemy-slot-placeholder" style={{ width: this.slotWidth(slot) }}/> }
          </div>
        })
      }
      </div>
    );
  }
}
